import React from "react";

import "./styles.css";

import CustomModal, {CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton} from "../..";
import { SVGAsset } from "res";

/**
 * @function AlreadyPaidBillModal
 * @param {FUNCTION} onClick - Sets and event handler on click for the ModalPrimaryButton 
 * @exported true
 * @returns  {React.Component}
 * @description A modal that is shown when you try to mark a bill as paid.
 * @example 
 * <AlreadyPaidBillModal onClick={props.onClick} />
 */
export default function AlreadyPaidBillModal(props) {
  const data = props.data ?? {};

  return (
    <CustomModal id="AlreadyPaidBillModal" className="already-paid-bill-modal large-icon-modal">
      <CustomModalContent className="flex-container flex-horizontal align-top">
        <div className="set-width">
          <SVGAsset id="UpsellIcon" className="info-icon left-icon blue-icon" />
        </div>
        <div className="flex-width">
          <h3 className="modal-title"><b>I already paid this bill</b></h3>
          <p className="sub-text">If you've already paid this bill another way, we can remove it from your list.</p>
        </div>
      </CustomModalContent>
      <CustomModalFooter className="form-button-container button-container flex-container flex-horizontal align-center">
        <ModalCloseButton id="AlreadyPaidBillModal" />
        <ModalPrimaryButton text="Mark as paid" onClick={ data.markAsPaid } />
      </CustomModalFooter>
    </CustomModal>
  );
}